import { useNavigate } from '@tanstack/react-router';
import { useDeleteAccount } from '../../api/mutations';
import { ConfirmButton } from '../../components/ConfirmButton';
import { errorMessage } from '../../lib/api';
import styles from './settings.module.css';

export function DangerZone() {
  const navigate = useNavigate();
  const remove = useDeleteAccount();
  const onConfirm = (): void => remove.mutate(undefined, { onSuccess: () => void navigate({ to: '/sign-in' }) });
  return (
    <section className={styles.danger} aria-labelledby="danger-title">
      <h2 id="danger-title" className={styles.dangerTitle}>DANGER ZONE</h2>
      <p className={styles.dangerBody}>
        Deletes your account, every ride, every file, and revokes PainPal&apos;s Strava access. This can&apos;t be undone.
      </p>
      <ConfirmButton
        label="DELETE ACCOUNT & ALL DATA" confirmLabel="YES, DELETE EVERYTHING" prompt="THIS CAN’T BE UNDONE."
        className="btn btn-hot" busy={remove.isPending} onConfirm={onConfirm}
      />
      {remove.isError && <p role="alert" className={`alert-hot ${styles.formError}`}>{errorMessage(remove.error)}</p>}
    </section>
  );
}
